export default "__VITE_ASSET__CGgM6r_J__$_?url__"